import React from 'react';
import { StyleSheet } from 'react-native';
import { useSelector } from 'react-redux';
import SpaceUtilizationWidget from './SpaceUtilizationWidget';
import BarGraph from '../../../../graphs/BarGraph';
import { DateRange } from '../../../../redux/dateRangeSlice';
import LineGraph from '../../../../graphs/LineGraph';
import BookingIcon16 from '../../../16pxIcons/BookingIcon16';
import Colors from '../../../../constants/Colors';
import { ChartDataPoint } from '../../../../graphs/axisUtils';
import { getRangeHours } from '../../../../constants/Utils';

interface BookingsGraphProps {
  chartData: ChartDataPoint[],
  comparisonData: ChartDataPoint[],
}

const BookingsGraph = ({ chartData, comparisonData }: BookingsGraphProps) => {
  const range: DateRange = useSelector((state: { dateRange: DateRange }) => state.dateRange);
  const compareRange: DateRange = useSelector((state:
    { dateComparisonRange: DateRange }) => (state.dateComparisonRange));
  const showBarGraph: boolean = !(!!compareRange.start && !!compareRange.end)
    && getRangeHours(range) / 24 < 8;
  const unit: string = getRangeHours(range) > 24 ? 'Hours' : 'Minutes';
  const axisLabel: string = `Booked time (${unit.toLowerCase()})`;
  const title: string = 'Booked time';

  return <SpaceUtilizationWidget
    icon={<BookingIcon16 />}
    title='Bookings'
    tooltipText='Shows total booked time over regular intervals during the selected date range'
    showTooltipOverContent
    content={showBarGraph ? <BarGraph
      {...{
        unit, axisLabel, title, chartData, range,
      }}
      selectedColor={Colors.light.hereworksDarkBlue200}
      chartHeight={315}
      horizontalTickCount={Math.min((chartData?.length ?? 0) + 1, 12)}
      timeFormat
      hideTimeOnTooltip
    /> : <LineGraph
      {...{
        unit, axisLabel, title, range, chartData, comparisonData,
      }}
      noTitle
      chartHeight={420}
      style={styles.lineGraph}
      hideTimeOnTooltip
    />}
  />;
};

const styles = StyleSheet.create({
  lineGraph: {
    marginTop: -70,
    marginStart: -24,
    marginEnd: 20,
    marginBottom: -18,
  },
});

export default BookingsGraph;
